var vars = require('./core');

module.exports = vars.createClass('PolarArea', ['getSegmentsAtEvent']);



// WEBPACK FOOTER //
// ./src/Scripts/react-chartjs/lib/polar-area.js